import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox, VBox } from '../../../components/Box';
import { Button } from '../../../components/Buttons';
import { Card } from '../../../components/Card';
import { Check, IsOpen, Times, ArrowDown, Edit, Trash } from '../../../components/Icon';
import { Modal, ModalControls } from '../../../components/Modal';
import {
  DEP_FINANCE,
  DEP_COMMERCE,
  DEP_WALSTREET,
  DEP_ADMINISTRATION,
  DEP_IT,
  DEP_WORKSHOP,
  DEP_ADMIN,
  DEP_TRANSPORT,
} from '../../../components/Permission/constants';
import { FormField } from '../../../components/FormFields';
import Dropdown from '../../../components/Dropdown/ReactDropdown';
import { Loader } from '../../../components/Loader';
import { ChangeLocationModal } from './ChangeLocationModal';
import { WithCompany } from '../../Companies/components/WithCompany';
import { CompanyLabel } from '../../Companies/components/CompanyLabel';
import { COLOR_SECONDARY_1 } from '../../../vars';
import { setVehicleProperties, setVehicleProperty, deleteVehicleProperty, fetchVehicle } from '../actions';
import { fetchAddress } from '../../Address/actions';
import { fetchCompany, updateAddress } from '../../Companies/actions';
import { selectCompany, selectCountries } from '../../Companies/selectors';
import { selectWorks, selectPermissions } from '../../Api/selectors';
import { getPropByName } from '../../../utils/props';
import { IDW_ADDRESSES } from '../../Address/constants';
import { REQUEST_VEHICLE_PROPERTIES, REQUEST_VEHICLE_PROPERTY_UPDATE } from '../constants';
import _ from 'lodash';
import { REQUEST_COMPANY } from '../../Companies/constants';
import {} from '../../../components/Permission';
import { Permission } from '../../../components/Permission';
import { VEHICLE_REMOVE } from '../../../components/Permission/constants';
import { TransportAssignable } from '../../KanbanBoards/cells/Transport/Transport_1_nl_in';
import { formatCurrency } from '../../../utils/string';
import ModalComponent from '../../../containers/App/Components/Modal/Modal';
import cn from 'classnames';

import styles from './CardTransport.module.css';
import ButtonComponent from '../../../containers/App/Components/Button/Button';
import { makeSelectLocale } from '../../../containers/LanguageProvider/selectors';
import { translateCountry } from '../../Companies/translate-countries';
import { hasPermissions } from '../../../utils/helpers/permissions';

const Container = styled.div`
  .started {
    margin: 12px 0;
    font-weight: 600;
  }
  .sub-title {
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    text-align: left;
    width: 100%;
    margin: 12px 0 0;
  }
  .address {
    border: 1px solid var(--color-new-grey);
    border-radius: 12px;
    padding: 12px;
    margin: 12px;
    .name {
      font-weight: 600;
    }

    &.selected {
      border: 2px solid var(--color-new-secondary);
    }
  }
  .dropdown-block {
    min-height: 300px;
  }

  .dropdown {
    min-width: 250px;
  }
`;
let date_done = new Date().toISOString();

const STATE = {
  init: false,
  direction: 'incoming',
  outgoing_from_address: null,
  outgoing_to_address: null,
  from_address: null,
  to_address: null,
  individual_from_address: null,
  individual_to_address: null,
  toPostcode: null,
  fromPostcode: null,
  is_nl: null,
  takeout: false,
  isOpen: false,
  showIncomingAddressEdit: false,
  showOutgoingAddressEdit: false,
  showIndividualAddressEdit: false,
};

const IDW_ADDRESSES_ID = IDW_ADDRESSES.map(a => ({ id: a.id, postcode: a?.postcode }));

/* eslint-disable react/prefer-stateless-function */
class VehicleTransportCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (hasPermissions(this.props.permissions, DEP_FINANCE || DEP_COMMERCE || DEP_ADMINISTRATION)) {
      this.setState({ isOpen: true });
    }
    if (!this.props.creditorCompany?.id) {
      this.props.fetchCompany(this.props.vehicle?.creditor_company);
    }
    this.transportAddressFrom;
    this.transportAddressTo;
    this.outgoingTransportAddressFrom;
    this.outgoingTransportAddressTo;
    this.individualTransportAddressFrom;
    this.individualTransportAddressTo;

    if (this.props.vehicle?.transport_from_address_id) {
      this.setState({ from_address: this.props.vehicle?.transport_from_address_id });
    }
    if (this.props.vehicle?.transport_to_address_id) {
      this.setState({ to_address: this.props.vehicle?.transport_to_address_id });
    }
    if (this.props.vehicle?.transport_outgoing_from_address_id) {
      this.setState({ outgoing_from_address: this.props.vehicle?.transport_outgoing_from_address_id });
    }
    if (this.props.vehicle?.transport_outgoing_to_address_id) {
      this.setState({ outgoing_to_address: this.props.vehicle?.transport_outgoing_to_address_id });
    }

    if (this.props.vehicle?.transport_individual_from_address_id) {
      this.setState({ individual_from_address: this.props.vehicle?.transport_individual_from_address_id });
    }
    if (this.props.vehicle?.transport_individual_to_address_id) {
      this.setState({ individual_to_address: this.props.vehicle?.transport_individual_to_address_id });
    }

    if (this.props.vehicle?.transport_individual_to_company_id) {
      this.props.fetchCompany(this.props.vehicle?.transport_individual_to_company_id, result => {
        this.setState({ selectedIndividualTransportTo: result });
      });
    }

    if (this.props.vehicle?.transport_individual_from_company_id) {
      this.props.fetchCompany(this.props.vehicle?.transport_individual_from_company_id, result => {
        this.setState({ selectedIndividualTransportFrom: result });
      });
    }

    if (this.props.vehicle?.transport_incoming_to_company_id) {
      this.props.fetchCompany(this.props.vehicle?.transport_incoming_to_company_id, result => {
        this.setState({ selectedTransportTo: result });
      });
    }

    if (this.props.vehicle?.transport_incoming_from_company_id) {
      this.props.fetchCompany(this.props.vehicle?.transport_incoming_from_company_id, result => {
        this.setState({ selectedTransportFrom: result });
      });
    }

    if (this.props.vehicle?.transport_outgoing_from_company_id) {
      this.props.fetchCompany(this.props.vehicle?.transport_outgoing_from_company_id, result => {
        this.setState({ selectedOutgoingTransportFrom: result });
      });
    }

    if (this.props.vehicle?.transport_outgoing_to_company_id) {
      this.props.fetchCompany(this.props.vehicle?.transport_outgoing_to_company_id, result => {
        this.setState({ selectedOutgoingTransportTo: result });
      });
    }

    if (!this.props.vehicle?.transport_outgoing_to_company_id && this.props.vehicle?.invoice_outgoing_company_id) {
      this.props.fetchCompany(this.props.vehicle?.invoice_outgoing_company_id, result => {
        this.setState({ selectedOutgoingTransportTo: result });
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.vehicle?.transport_from_address_id !== this.props.vehicle?.transport_from_address_id) {
      this.transportAddressFrom;
    }

    if (prevProps.vehicle?.transport_to_address_id !== this.props.vehicle?.transport_to_address_id) {
      this.transportAddressTo;
    }
    if (prevProps.vehicle?.transport_outgoing_from_address_id !== this.props.vehicle?.transport_outgoing_from_address_id) {
      this.outgoingTransportAddressFrom;
    }

    if (prevProps.vehicle?.transport_outgoing_to_address_id !== this.props.vehicle?.transport_outgoing_to_address_id) {
      this.outgoingTransportAddressTo;
    }

    if (
      prevProps.vehicle?.transport_individual_from_address_id !== this.props.vehicle?.transport_individual_from_address_id
    ) {
      this.individualTransportAddressFrom;
    }

    if (prevProps.vehicle?.transport_individual_to_address_id !== this.props.vehicle?.transport_individual_to_address_id) {
      this.individualTransportAddressTo;
    }
  }

  get transportAddressFrom() {
    this.props.vehicle?.transport_from_address_id &&
      this.props.fetch(this.props.vehicle?.transport_from_address_id, res => {
        return this.setState({ vehicleAddressFrom: res });
      });
  }

  get transportAddressTo() {
    const idwAddress = IDW_ADDRESSES_ID.find(a => this.props.vehicle?.transport_to_address_id == a.id);
    this.props.vehicle?.transport_to_address_id && idwAddress?.id
      ? this.setState({ vehicleAddressTo: this.props.vehicle?.transport_to_address_id, toPostcode: idwAddress?.postcode })
      : this.props.fetch(
          this.props.vehicle?.transport_to_address_id,
          res => res?.id && this.setState({ vehicleAddressTo: res, toPostcode: res?.postcode }),
        );
  }

  get outgoingTransportAddressFrom() {
    const idwAddress = IDW_ADDRESSES_ID.find(a => this.props.vehicle?.transport_outgoing_from_address_id == a.id);
    if (idwAddress?.id) {
      this.setState({
        vehicleOutgoingAddressFrom: this.props.vehicle?.transport_outgoing_from_address_id,
        fromPostcode: idwAddress?.postcode,
      });
    } else {
      this.props.vehicle?.transport_outgoing_from_address_id &&
        this.props.fetch(this.props.vehicle.transport_outgoing_from_address_id, res =>
          this.setState({ vehicleOutgoingAddressFrom: res, fromPostcode: res?.postcode }),
        );
    }
  }

  get outgoingTransportAddressTo() {
    if (this.props.vehicle?.transport_outgoing_to_address_id) {
      this.props.fetch(this.props.vehicle?.transport_outgoing_to_address_id, res =>
        this.setState({ vehicleOutgoingAddressTo: res, toPostcode: res?.postcode }),
      );
    }
  }

  get individualTransportAddressFrom() {
    const idwAddress = IDW_ADDRESSES_ID.find(a => this.props.vehicle?.transport_individual_from_address_id == a.id);
    if (idwAddress?.id) {
      this.setState({
        vehicleIndividualAddressFrom: this.props.vehicle?.transport_individual_from_address_id,
        fromPostcode: idwAddress?.postcode,
      });
    } else {
      this.props.vehicle?.transport_individual_from_address_id &&
        this.props.fetch(this.props.vehicle.transport_individual_from_address_id, res =>
          this.setState({ vehicleIndividualAddressFrom: res, fromPostcode: res?.postcode }),
        );
    }
  }

  get individualTransportAddressTo() {
    if (this.props.vehicle?.transport_individual_to_address_id) {
      this.props.fetch(this.props.vehicle?.transport_individual_to_address_id, res =>
        this.setState({ vehicleIndividualAddressTo: res, toPostcode: res?.postcode }),
      );
    }
  }

  get countries() {
    return this.props.countries;
  }

  get locale() {
    return this.props.locale;
  }

  get countryOptions() {
    const options = this.countries.map(c => ({ value: c.id, label: translateCountry(c.name, this.locale) }));
    return options;
  }

  get incomingIsNl() {
    const is_nl =
      (this.state.selectedTransportFrom?.company_from_eu?.toLowerCase?.() == 'nl' ||
        getPropByName(this.state.selectedTransportFrom, 'company_from_eu')?.toLowerCase?.() == 'nl') &&
      (this.state.selectedTransportTo?.company_from_eu?.toLowerCase?.() == 'nl' ||
        getPropByName(this.state.selectedTransportTo, 'company_from_eu')?.toLowerCase?.() == 'nl');

    return is_nl;
  }

  get outgoingIsNl() {
    const is_nl =
      (this.state.selectedOutgoingTransportFrom?.company_from_eu?.toLowerCase?.() == 'nl' ||
        getPropByName(this.state.selectedOutgoingTransportFrom, 'company_from_eu')?.toLowerCase?.() == 'nl') &&
      (this.state.selectedOutgoingTransportTo?.company_from_eu?.toLowerCase?.() == 'nl' ||
        getPropByName(this.state.selectedOutgoingTransportTo, 'company_from_eu')?.toLowerCase?.() == 'nl');

    return is_nl;
  }

  get individualIsNl() {
    const is_nl =
      (this.state.selectedIndividualTransportFrom?.company_from_eu?.toLowerCase?.() == 'nl' ||
        getPropByName(this.state.selectedIndividualTransportFrom, 'company_from_eu')?.toLowerCase?.() == 'nl') &&
      (this.state.selectedIndividualTransportTo?.company_from_eu?.toLowerCase?.() == 'nl' ||
        getPropByName(this.state.selectedIndividualTransportTo, 'company_from_eu')?.toLowerCase?.() == 'nl');

    return is_nl;
  }

  onIncomingAddressUpdate = direction => {
    let company = this.state.selectedTransportFrom || this.props.creditorCompany;
    if (direction == 'to') {
      company = this.state.selectedTransportTo;
    }
    this.props.updateAddress(
      company?.id,
      this.state.dtoAddressId,
      {
        countryId: this.state.country?.value,
      },
      result => {
        if (result?.id) {
          const updatedAddress = result?.addresses?.filter(address => address?.id == this.state.dtoAddressId);

          direction == 'from'
            ? this.setState({
                selectedTransportFrom: result,
                selectedAddressFrom: updatedAddress,
                showIncomingAddressEdit: false,
                transportFromChange: false,
                from_address: result?.id,
                fromAddressEdit: false,
                fromPostcode: updatedAddress?.postcode,
              })
            : this.setState({
                selectedTransportTo: result,
                selectedAddressTo: updatedAddress,
                showIncomingAddressEdit: false,
                transportToChange: false,
                from_address: result?.id,
                toAddressEdit: false,
                toPostcode: updatedAddress?.postcode,
              });
          return direction == 'from' ? this.transportAddressFrom : this.transportAddressTo;
        }
      },
    );
  };

  onOutgoingAddressUpdate = direction => {
    let company = this.state.selectedOutgoingTransportFrom;
    if (direction == 'to') {
      company = this.state.selectedOutgoingTransportTo || this.props.vehicle.buyingCompany;
    }
    this.props.updateAddress(
      company?.id,
      this.state.dtoAddressId,
      {
        countryId: this.state.country?.value,
      },
      result => {
        if (result?.id) {
          const updatedAddress = result?.addresses?.filter(address => address?.id == this.state.dtoAddressId);

          direction == 'from'
            ? this.setState({
                selectedOutgoingTransportFrom: result,
                selectedOutgoingAddressFrom: updatedAddress,
                showOutgoingAddressEdit: false,
                outgoingTransportFromChange: false,
                outgoing_from_address: result?.id,
                fromOutgAddressEdit: false,
              })
            : this.setState({
                selectedOutgoingTransportTo: result,
                selectedOutgoingAddressTo: updatedAddress,
                showOutgoingAddressEdit: false,
                outgoingTransportToChange: false,
                outgoing_from_address: result?.id,
                toOutgAddressEdit: false,
              });
          return direction == 'from' ? this.outgoingTransportAddressFrom : this.outgoingTransportAddressTo;
        }
      },
    );
  };

  onIndividualAddressUpdate = direction => {
    let company = this.state.selectedIndividualTransportFrom;
    if (direction == 'to') {
      company = this.state.selectedIndividualTransportTo || this.props.vehicle.buyingCompany;
    }
    this.props.updateAddress(
      company?.id,
      this.state.dtoAddressId,
      {
        countryId: this.state.country?.value,
      },
      result => {
        if (result?.id) {
          const updatedAddress = result?.addresses?.filter(address => address?.id == this.state.dtoAddressId);

          direction == 'from'
            ? this.setState({
                selectedIndividualTransportFrom: result,
                selectedIndividualAddressFrom: updatedAddress,
                showIndividualAddressEdit: false,
                individualTransportFromChange: false,
                individual_from_address: result?.id,
                fromIndividualAddressEdit: false,
              })
            : this.setState({
                selectedIndividualTransportTo: result,
                selectedIndividualAddressTo: updatedAddress,
                showIndividualAddressEdit: false,
                individualTransportToChange: false,
                individual_from_address: result?.id,
                toIndividualAddressEdit: false,
              });
          return direction == 'from' ? this.individualTransportAddressFrom : this.individualTransportAddressTo;
        }
      },
    );
  };

  onSetIndividualLocationFrom = (company, address) => {
    if (!address?.country?.name) {
      this.setState({
        showIndividualAddressEdit: true,
        selectedIndividualTransportFrom: company,
        dtoAddressId: address?.id,
        fromIndividualAddressEdit: true,
      });

      return;
    }
    this.setState({
      selectedIndividualTransportFrom: company,
      selectedIndividualAddressFrom: address,
      individualTransportFromChange: false,
      individual_from_address: address?.id,
    });
  };

  onSetIndividualLocationTo = (company, address) => {
    if (!address?.country?.name) {
      this.setState({
        showIndividualAddressEdit: true,
        selectedIndividualTransportTo: company,
        dtoAddressId: address?.id,
        toIndividualAddressEdit: true,
      });

      return;
    }

    this.setState({
      selectedIndividualTransportTo: company,
      selectedIndividualAddressTo: address,
      individualTransportToChange: false,
      individual_to_address: address?.id,
    });
  };

  onSetLocationFrom = (company, address) => {
    if (!address?.country?.name) {
      this.setState({
        showIncomingAddressEdit: true,
        selectedTransportFrom: company,
        dtoAddressId: address?.id,
        fromAddressEdit: true,
        fromPostcode: address?.postcode,
      });

      return;
    }
    this.setState({
      selectedTransportFrom: company,
      selectedAddressFrom: address,
      transportFromChange: false,
      from_address: address?.id,
      fromPostcode: address?.postcode,
    });
  };

  onSetLocationTo = (company, address) => {
    if (!address?.country?.name) {
      this.setState({
        showIncomingAddressEdit: true,
        selectedTransportTo: company,
        dtoAddressId: address?.id,
        toAddressEdit: true,
        toPostcode: address?.postcode,
      });

      return;
    }

    this.setState({
      selectedTransportTo: company,
      selectedAddressTo: address,
      transportToChange: false,
      to_address: address?.id,
      toPostcode: address?.postcode,
    });
  };

  onSetOutgoingLocationFrom = (company, address) => {
    if (!address?.country?.name) {
      this.setState({
        showOutgoingAddressEdit: true,
        selectedOutgoingTransportFrom: company,
        dtoAddressId: address?.id,
        fromOutgAddressEdit: true,
        fromPostcode: address?.postcode,
      });

      return;
    }

    this.setState({
      selectedOutgoingTransportFrom: company,
      selectedOutgoingAddressFrom: address,
      outgoingTransportFromChange: false,
      outgoing_from_address: address?.id,
      fromPostcode: address?.postcode,
    });
  };

  onSetOutgoingLocationTo = (company, address) => {
    if (!address?.country?.name) {
      this.setState({
        showOutgoingAddressEdit: true,
        selectedOutgoingTransportTo: company,
        dtoAddressId: address?.id,
        toOutgAddressEdit: true,
        toPostcode: address?.postcode,
      });

      return;
    }

    this.setState({
      selectedOutgoingTransportTo: company,
      selectedOutgoingAddressTo: address,
      outgoingTransportToChange: false,
      outgoing_to_address: address?.id,
      toPostcode: address?.postcode,
    });
  };

  reset() {
    this.setState({
      init: false,
      direction: 'incoming',
      is_nl: null,
      takeout: false,
      isOpen: false,
      showIncomingAddressEdit: false,
      showOutgoingAddressEdit: false,
      showIndividualAddressEdit: false,
    });
  }

  start() {
    const postcodeFrom = this.state.fromPostcode ?? '';

    const postcodeTo = this.state.toPostcode ?? '';

    if (this.state.direction == 'incoming') {
      const incomCompanyFromName =
        this.state.selectedTransportFrom?.name || getPropByName(this.state.selectedTransportFrom, 'name') || '-';
      const incomCompanyToName =
        this.state.selectedTransportTo?.name || getPropByName(this.state.selectedTransportTo, 'name') || '-';

      return this.props.start(
        this.state.direction,
        this.state.from_address,
        this.state.to_address,
        this.state.selectedTransportFrom?.id || this.props.vehicle?.transport_from_address_id,
        incomCompanyFromName,
        this.state.selectedTransportTo?.id || this.props.vehicle?.transport_to_address_id,
        incomCompanyToName,
        postcodeFrom,
        postcodeTo,
        this.incomingIsNl,
        this.reset.bind(this),
      );
    }

    if (this.state.direction == 'outgoing') {
      const outgCompanyFromName =
        this.selectedOutgoingTransportFrom?.name || getPropByName(this.state.selectedOutgoingTransportFrom, 'name') || '-';
      const outgCompanyToName =
        this.state.selectedOutgoingTransportTo?.name || getPropByName(this.state.selectedOutgoingTransportTo, 'name') || '-';

      return this.props.start(
        this.state.direction,
        this.state.outgoing_from_address,
        this.state.outgoing_to_address,
        this.state.selectedOutgoingTransportFrom?.id || this.props.vehicle?.transport_outgoing_from_address_id,
        outgCompanyFromName,
        this.state.selectedOutgoingTransportTo?.id || this.props.vehicle?.transport_outgoing_to_address_id,
        outgCompanyToName,
        postcodeFrom,
        postcodeTo,
        this.outgoingIsNl,
        this.reset.bind(this),
      );
    }

    if (this.state.direction == 'individual') {
      const individualCompanyFromName =
        this.selectedIndividualTransportFrom?.name ||
        getPropByName(this.state.selectedIndividualTransportFrom, 'name') ||
        '-';
      const individualCompanyToName =
        this.state.selectedIndividualTransportTo?.name ||
        getPropByName(this.state.selectedIndividualTransportTo, 'name') ||
        '-';

      return this.props.start(
        this.state.direction,
        this.state.individual_from_address,
        this.state.individual_to_address,
        this.state.selectedIndividualTransportFrom?.id || this.props.vehicle?.transport_individual_from_address_id,
        individualCompanyFromName,
        this.state.selectedIndividualTransportTo?.id || this.props.vehicle?.transport_individual_to_address_id,
        individualCompanyToName,
        postcodeFrom,
        postcodeTo,
        this.individualIsNl,
        this.reset.bind(this),
      );
    }
  }

  onDeleteIndividual() {
    this.props.deleteProperty(this.props.vehicle?.id, [
      'transport_individual_from_address_id',
      'transport_individual_to_address_id',
      'transport_individual_from_company_id',
      'transport_individual_to_company_id',
      'transport_individual_from_company_name',
      'transport_individual_to_company_name',
      'transport_direction',
      'transport_individual_is_nl',
      'direction',
      'transport_individual_filled_date',
      'transport_individual_requested',
      'transport_individual_initiated',
      'transport_individual_assigned_to',
      // 'transport_assigned_to',
    ]);

    this.setState({
      vehicleIndividualAddressFrom: null,
      vehicleIndividualAddressTo: null,
      individual_from_address: null,
      individual_to_address: null,
      fromPostcode: null,
      toPostcode: null,
    });
    return this.props.fetchVehicle();
  }

  onDeleteIncoming() {
    this.props.deleteProperty(this.props.vehicle?.id, [
      'transport_from_address_id',
      'transport_to_address_id',
      'transport_incoming_from_company_id',
      'transport_incoming_to_company_id',
      'transport_incoming_from_company_name',
      'transport_incoming_to_company_name',
      'transport_direction',
      'transport_is_nl',
      'transport_incoming_is_nl',
      'transport_done',
      'transport_requested',
      'transport_initiated',
      'action_ws1_1_labels_done',
      'transport_assigned_to',
    ]);

    this.setState({
      vehicleAddressFrom: null,
      vehicleAddressTo: null,
      from_address: null,
      to_address: null,
      fromPostcode: null,
      toPostcode: null,
    });
    return this.props.fetchVehicle();
  }

  onDeleteOutgoing() {
    this.props.deleteProperty(this.props.vehicle?.id, [
      'transport_outgoing_from_address_id',
      'transport_outgoing_to_address_id',
      'transport_outgoing_from_company_id',
      'transport_outgoing_to_company_id',
      'transport_outgoing_from_company_name',
      'transport_outgoing_to_company_name',
      'direction',
      'transport_outgoing_is_nl',
      'transport_outgoing_requested',
      'transport_outgoing_is_nl',
      'transport_outgoing_assigned_to',
      'transport_outgoing_initiated',
      'transport_outgoing_done',
    ]);

    this.setState({
      vehicleOutgoingAddressFrom: null,
      vehicleOutgoingAddressTo: null,
      outgoing_from_address: null,
      outgoing_to_address: null,
      fromPostcode: null,
      toPostcode: null,
    });
    return this.props.fetchVehicle();
  }

  render() {
    if (this.props.work) return <Loader />;
    const vehicle = this.props.vehicle;
    let companyId = parseInt(getPropByName(this.props.vehicle, 'creditor_company'));
    const outgoingAssignedTo = vehicle?.transport_outgoing_assigned_to;
    let nameOutgoing = '';
    {
      outgoingAssignedTo != '1'
        ? (nameOutgoing =
            Object.keys(TransportAssignable).find(key => TransportAssignable[key] === outgoingAssignedTo) || '')
        : (nameOutgoing = vehicle?.transporter_extern);
    }

    const incomingAssignedTo = vehicle?.transport_assigned_to;
    let nameIncoming = '';
    {
      incomingAssignedTo != '1'
        ? (nameIncoming =
            Object.keys(TransportAssignable).find(key => TransportAssignable[key] === incomingAssignedTo) || '')
        : (nameIncoming = vehicle?.transporter_extern);
    }
    const individualAssignedTo = vehicle?.transport_individual_assigned_to;
    let nameIndividual = '';
    {
      individualAssignedTo != '1'
        ? (nameIndividual =
            Object.keys(TransportAssignable).find(key => TransportAssignable[key] === individualAssignedTo) || '')
        : (nameIndividual = vehicle?.transporter_extern);
    }
    return (
      <Card className={cn('vehicle-info-card info-card data', styles.card)}>
        <Container>
          <HBox>
            <h2 className="card-title mb-0 text-muted">{this.lbl('vehicle.info.transport')}</h2>

            <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
              <IsOpen />
            </div>
          </HBox>
          {this.state.isOpen && (
            <>
              {/* {vehicle.transport_requested == '1' ? ( */}
              {/* vehicle.transport_initiated == '1'*/}
              <VBox center>
                <HBox vCenter className={styles.titleBox}>
                  <h2 className="text-muted">{this.lbl('vehicle.info.incoming_transport')}</h2>
                  <div style={{ display: 'flex', gap: '5px' }}>
                    <ButtonComponent
                      style={'ButtonSoftEdit'}
                      size={'btn-sm'}
                      onClick={this.setStateFn({ direction: 'incoming', init: true })}
                    >
                      <Edit />
                    </ButtonComponent>

                    <ButtonComponent style={'ButtonSoftDelete'} size={'btn-sm'} onClick={this.onDeleteIncoming.bind(this)}>
                      <Times />
                    </ButtonComponent>
                  </div>
                </HBox>
                {this.state.vehicleAddressFrom &&
                  this.renderAddress(
                    this.state.vehicleAddressFrom,
                    true,
                    () => {},
                    vehicle?.transport_incoming_from_company_name,
                  )}
                {this.state.vehicleAddressTo && (
                  <div>
                    <ArrowDown />
                  </div>
                )}
                {IDW_ADDRESSES_ID.includes(this.state.vehicleAddressTo)
                  ? IDW_ADDRESSES.map(a => {
                      if (a.id == this.state.vehicleAddressTo) {
                        return this.renderAddress(a, true, () => {}, vehicle?.transport_incoming_to_company_name);
                      }
                    })
                  : this.state.vehicleAddressTo &&
                    this.renderAddress(
                      this.state.vehicleAddressTo,
                      true,
                      () => {},
                      vehicle?.transport_incoming_to_company_name,
                    )}
                <HBox vCenter className={styles.titleBox}>
                  <h2 className="text-muted">{this.lbl('vehicle.info.outgoing_transport')}</h2>
                  <div style={{ display: 'flex', gap: '5px' }}>
                    <ButtonComponent
                      style={'ButtonSoftEdit'}
                      size={'btn-sm'}
                      onClick={this.setStateFn({ direction: 'outgoing', init: true })}
                    >
                      <Edit />
                    </ButtonComponent>
                    <ButtonComponent style={'ButtonSoftDelete'} size={'btn-sm'} onClick={this.onDeleteOutgoing.bind(this)}>
                      <Times />
                    </ButtonComponent>
                  </div>
                </HBox>
                {IDW_ADDRESSES_ID.includes(this.state.vehicleOutgoingAddressFrom)
                  ? IDW_ADDRESSES.map(a => {
                      if (a.id == this.state.vehicleOutgoingAddressFrom) {
                        return this.renderAddress(a, true, () => {}, vehicle?.transport_outgoing_from_company_name);
                      }
                    })
                  : this.state.vehicleOutgoingAddressFrom &&
                    this.renderAddress(
                      this.state.vehicleOutgoingAddressFrom,
                      true,
                      () => {},
                      vehicle?.transport_outgoing_from_company_name,
                    )}

                {this.state.vehicleOutgoingAddressTo && (
                  <div>
                    <ArrowDown />
                  </div>
                )}
                {this.state.vehicleOutgoingAddressTo &&
                  this.renderAddress(
                    this.state.vehicleOutgoingAddressTo,
                    true,
                    () => {},
                    vehicle?.transport_outgoing_to_company_name,
                  )}
                <Permission permission={VEHICLE_REMOVE}>
                  <HBox vCenter className={styles.titleBox}>
                    <h2 className="text-muted">{this.lbl('vehicle.info.individual_transport')}</h2>
                    <div style={{ display: 'flex', gap: '5px' }}>
                      <ButtonComponent
                        style={'ButtonSoftEdit'}
                        size={'btn-sm'}
                        onClick={this.setStateFn({ direction: 'individual', init: true })}
                      >
                        <Edit />
                      </ButtonComponent>

                      <ButtonComponent
                        style={'ButtonSoftDelete'}
                        size={'btn-sm'}
                        onClick={this.onDeleteIndividual.bind(this)}
                      >
                        <Times />
                      </ButtonComponent>
                    </div>
                  </HBox>
                </Permission>
                {IDW_ADDRESSES_ID.includes(this.state.vehicleIndividualAddressFrom)
                  ? IDW_ADDRESSES.map(a => {
                      if (a.id == this.state.vehicleIndividualAddressFrom) {
                        return this.renderAddress(a, true, () => {}, vehicle?.transport_individual_from_company_name);
                      }
                    })
                  : this.state.vehicleIndividualAddressFrom &&
                    this.renderAddress(
                      this.state.vehicleIndividualAddressFrom,
                      true,
                      () => {},
                      vehicle?.transport_individual_from_company_name,
                    )}

                {this.state.vehicleIndividualAddressTo && (
                  <div>
                    <ArrowDown />
                  </div>
                )}
                {this.state.vehicleIndividualAddressTo &&
                  this.renderAddress(
                    this.state.vehicleIndividualAddressTo,
                    true,
                    () => {},
                    vehicle?.transport_individual_to_company_name,
                  )}
              </VBox>
              {!vehicle.transport_done ? 'Inkomend ingepland voor:' : 'Inkomend afgerond door:'} {nameIncoming} <br />
              {!vehicle.transport_outgoing_completed_date
                ? ''
                : new Date(vehicle?.transport_completed_date).toLocaleDateString('nl-NL')}
              {!vehicle.transport_outgoing_done ? 'Uitgaand ingepland voor:' : 'Uitgaand afgerond door:'} {nameOutgoing}{' '}
              <br />
              {!vehicle.transport_outgoing_completed_date
                ? ''
                : new Date(vehicle?.transport_outgoing_completed_date).toLocaleDateString('nl-NL')}
              {!vehicle.transport_done ? 'Individueel ingepland voor:' : 'Individueel afgerond door:'} {nameIndividual}{' '}
              <br />
              {!vehicle.transport_individual_completed_date
                ? ''
                : new Date(vehicle?.transport_individual_completed_date).toLocaleDateString('nl-NL')}
              <Permission permission={VEHICLE_REMOVE}>
                <Button
                  className={styles.buttonWarningOverrule}
                  onClick={() => {
                    if (vehicle.overrule_outgoing_transport == null || vehicle.overrule_outgoing_transport == 0) {
                      this.props.overrule_outgoing_transport(1);
                    } else if (vehicle.overrule_outgoing_transport == 1) {
                      this.props.overrule_outgoing_transport(0);
                    }
                  }}
                >
                  {vehicle.overrule_outgoing_transport == 1
                    ? 'Annuleer overrule uitgaand transport'
                    : 'Overrule uitgaand transport'}
                </Button>
              </Permission>
              <Button className={styles.button} onClick={() => this.setState({ takeout: true })}>
                Klaarzetten&nbsp;
                {vehicle.task_move_car_for_takeout == 'front' ? (
                  'VOOR'
                ) : vehicle.task_move_car_for_takeout == 'back' ? (
                  'ACHTER'
                ) : vehicle.task_move_car_for_takeout == 'done' ? (
                  <Check />
                ) : (
                  ''
                )}
              </Button>
              <Button
                className={styles.button}
                disabled={vehicle.task_remove_plates == '1'}
                onClick={() => this.props.deplate()}
              >
                Platen verwijderen
              </Button>
              <HBox>
                <h2>{this.lbl('vehicle.info.international')}</h2>
              </HBox>
              <br />
              <HBox>
                <h2>{this.lbl('vehicle.info.international_incoming')}</h2>
              </HBox>
              <HBox>
                {this.lbl('vehicle.info.amount_transport_eu_in')}
                {formatCurrency(vehicle?.amount_transport_eu_in)}
              </HBox>
              <HBox>
                {this.lbl('vehicle.info.transporter_eu_in')} {vehicle?.transporter_eu_in}
              </HBox>
              <HBox>
                {this.lbl('vehicle.info.date_expected_start_eu_in')} {vehicle?.date_expected_start_eu_in}
              </HBox>
              <HBox>
                {this.lbl('vehicle.info.amount_of_vehicles')} {vehicle?.amount_of_vehicles_in}
              </HBox>
              <br />
              <HBox>
                <h2>{this.lbl('vehicle.info.international_outgoing')}</h2>
              </HBox>
              <HBox>
                {this.lbl('vehicle.info.amount_transport_eu_out')}
                {formatCurrency(vehicle?.amount_transport_eu_out)}
              </HBox>
              <HBox>
                {this.lbl('vehicle.info.transporter_eu_out')} {vehicle?.transporter_eu_out}
              </HBox>
              <HBox>
                {this.lbl('vehicle.info.date_expected_start_eu_out')} {vehicle?.date_expected_start_eu_out}
              </HBox>
              <HBox>
                {this.lbl('vehicle.info.amount_of_vehicles')} {vehicle?.amount_of_vehicles_out}
              </HBox>
              {this.renderModal()}
            </>
          )}
        </Container>
      </Card>
    );
  }

  renderModal() {
    if (this.state.takeout) return this.renderTakeoutModal();
    if (!this.state.init) return null;

    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.lbl('vehicle.transport.init')}>
        <Container>
          {this.renderModalBody()}
          <div className={styles.containerModalButton}>
            {this.state.direction == 'incoming' ? (
              <Button
                className={styles.buttonModal}
                disabled={!this.state.from_address || !this.state.to_address}
                onClick={this.start.bind(this)}
              >
                {this.lbl('vehicle.transport.init')}
              </Button>
            ) : this.state.direction == 'outgoing' ? (
              <Button
                className={styles.buttonModal}
                disabled={!this.state.outgoing_from_address || !this.state.outgoing_to_address}
                onClick={this.start.bind(this)}
              >
                {this.lbl('vehicle.transport.init')}
              </Button>
            ) : (
              <Button
                className={styles.buttonModal}
                disabled={!this.state.individual_from_address || !this.state.individual_to_address}
                onClick={this.start.bind(this)}
              >
                {this.lbl('vehicle.transport.init')}
              </Button>
            )}
            <Button className={styles.buttonWarning} onClick={this.reset.bind(this)}>
              {this.lbl('cancel')}
            </Button>
          </div>
        </Container>
      </ModalComponent>
    );
  }

  renderModalBody() {
    const is_nl =
      this.state.direction == 'incoming'
        ? this.incomingIsNl
        : this.state.direction == 'outgoing'
        ? this.outgoingIsNl
        : this.individualIsNl;
    return (
      <VBox center className={styles.containerDirectionButton}>
        <Button
          className={styles.buttonDirection}
          disabled={this.state.direction == 'outgoing' || this.state.direction == 'individual'}
          primary={this.state.direction == 'incoming'}
          onClick={this.setStateFn({ ...STATE, direction: 'incoming', init: true })}
        >
          {this.lbl('vehicle.transport.direction.incoming')}
        </Button>
        <Button
          className={styles.buttonDirection}
          disabled={this.state.direction == 'incoming' || this.state.direction == 'individual'}
          primary={this.state.direction == 'outgoing'}
          onClick={this.setStateFn({ ...STATE, direction: 'outgoing', init: true })}
        >
          {this.lbl('vehicle.transport.direction.outgoing')}
        </Button>
        <Button
          className={styles.buttonDirection}
          disabled={this.state.direction == 'incoming' || this.state.direction == 'outgoing'}
          primary={this.state.direction == 'individual'}
          onClick={this.setStateFn({ ...STATE, direction: 'individual', init: true })}
        >
          {this.lbl('vehicle.transport.direction.individual')}
        </Button>
        {this.state.direction == 'incoming'
          ? this.renderIncoming()
          : this.state.direction == 'outgoing'
          ? this.renderOutgoing()
          : this.state.direction == 'individual'
          ? this.renderIndividual()
          : null}

        {is_nl ? (
          <>
            <Check />
            Nationaal
          </>
        ) : null}
      </VBox>
    );
  }

  renderAddress(address, selected, onClick, company_name) {
    return (
      <VBox className={`address ${selected ? 'selected' : ''}`} key={address.id} onClick={onClick}>
        {company_name && company_name} <br />
        <div className="name">{this.lbl(`address.type.${address?.type?.name || 'other'}`)}</div>
        {address.addressLine1} <br /> {address.postcode}&nbsp;{address.city}
        <br />
        {translateCountry(address.country?.name, this.locale) || ''}
      </VBox>
    );
  }

  renderIncoming() {
    const company = this.state.selectedTransportFrom || this.props.creditorCompany;
    const homeCompany = {
      id: '4',
      name: "In de Wal Auto's B.V.",
      addresses: IDW_ADDRESSES,
      company_from_eu: 'NL',
    };
    const companyTo = this.state.selectedTransportTo?.addresses ? this.state.selectedTransportTo : homeCompany;
    const is_nl = company?.company_from_eu?.toLowerCase?.() == 'nl';
    const is_nl_to = companyTo?.company_from_eu?.toLowerCase?.() == 'nl';

    return (
      <>
        <div className="sub-title">
          {this.lbl('vehicle.transport.from')} <CompanyLabel company={company} />
        </div>
        {this.state.transportFromChange && (
          <ChangeLocationModal
            mediumWide={true}
            company={company}
            address={this.props.vehicle?.locationAddress}
            onClose={() => this.setState({ transportFromChange: false })}
            onConfirm={this.onSetLocationFrom}
          />
        )}
        <HBox center>
          <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.setStateFn({ transportFromChange: true })}>
            {this.lbl('vehicle.location.change_transport_from')}
          </ButtonComponent>
        </HBox>
        <VBox center>
          {company?.addresses?.length
            ? company.addresses.map(a =>
                this.renderAddress(a, this.state.from_address == a.id, () => {
                  a.country?.name
                    ? this.setState({ selectedTransportFrom: company, from_address: a.id, is_nl, fromPostcode: a?.postcode })
                    : this.setState({ showIncomingAddressEdit: true, dtoAddressId: a.id, fromAddressEdit: true, is_nl });
                }),
              )
            : null}
        </VBox>
        <div className="sub-title">{this.lbl('vehicle.transport.to')}:</div>
        <VBox center>
          {this.state.transportToChange && (
            <ChangeLocationModal
              mediumWide={true}
              company={this.state.selectedTransportTo}
              address={this.props.vehicle?.locationAddress}
              onClose={() => this.setState({ transportToChange: false })}
              onConfirm={this.onSetLocationTo}
            />
          )}
          {this.state.showIncomingAddressEdit && (
            <ModalComponent
              onClose={() => this.setState({ showIncomingAddressEdit: false })}
              title={this.lbl('company.property.select_country')}
            >
              <Container>
                <div className="dropdown-block">
                  <FormField>
                    <Dropdown
                      className="dropdown"
                      options={this.countryOptions}
                      value={this.state.country?.label}
                      onChange={evt => this.setState({ country: evt })}
                    />
                  </FormField>
                </div>
                <HBox center>
                  <Button
                    small
                    onClick={() => {
                      if (this.state.fromAddressEdit) {
                        return this.onIncomingAddressUpdate('from');
                      }
                      if (this.state.toAddressEdit) {
                        return this.onIncomingAddressUpdate('to');
                      }
                    }}
                  >
                    {this.lbl('confirm')}
                  </Button>
                </HBox>
              </Container>
            </ModalComponent>
          )}
          <HBox center>
            <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.setStateFn({ transportToChange: true })}>
              {this.lbl('vehicle.location.change_transport_to')}
            </ButtonComponent>
          </HBox>
          {companyTo.addresses.map(a =>
            this.renderAddress(a, this.state.to_address == a.id, () => {
              // debugger;
              a?.country?.name
                ? this.setState({
                    selectedTransportTo: companyTo,
                    to_address: a.id,
                    is_nl: is_nl_to,
                    toPostcode: a?.postcode,
                  })
                : this.setState({ showIncomingAddressEdit: true, dtoAddressId: a.id, toAddressEdit: true, is_nl: is_nl_to });
            }),
          )}
        </VBox>
      </>
    );
  }

  renderOutgoing() {
    const homeCompany = {
      id: '4',
      name: "In de Wal Auto's B.V.",
      addresses: IDW_ADDRESSES,
      company_from_eu: 'NL',
    };
    const companyFrom = this.state.selectedOutgoingTransportFrom ? this.state.selectedOutgoingTransportFrom : homeCompany;
    const companyTo = this.state.selectedOutgoingTransportTo?.addresses
      ? this.state.selectedOutgoingTransportTo
      : this.props.vehicle.buyingCompany;

    const is_nl = companyFrom?.company_from_eu?.toLowerCase?.() == 'nl';
    const is_nl_to = companyTo?.company_from_eu?.toLowerCase?.() == 'nl';

    return (
      <>
        <div className="sub-title">{this.lbl('vehicle.transport.from')}:</div>
        {this.state.outgoingTransportFromChange && (
          <ChangeLocationModal
            mediumWide={true}
            company={this.state.selectedOutgoingTransportFrom}
            address={this.props.vehicle?.locationAddress}
            onClose={() => this.setState({ outgoingTransportFromChange: false })}
            onConfirm={this.onSetOutgoingLocationFrom}
          />
        )}
        <HBox center>
          <ButtonComponent
            style={'ButtonSoftPrimary'}
            onClick={this.setStateFn({ direction: 'outgoing', init: true, outgoingTransportFromChange: true })}
          >
            {this.lbl('vehicle.location.change_transport_from')}
          </ButtonComponent>
        </HBox>
        <VBox center>
          {companyFrom.addresses.map(a =>
            this.renderAddress(a, this.state.outgoing_from_address == a.id, () => {
              a?.country?.name
                ? this.setState({
                    selectedOutgoingTransportFrom: companyFrom,
                    outgoing_from_address: a.id,
                    is_nl,
                    fromPostcode: a?.postcode,
                  })
                : this.setState({ showOutgoingAddressEdit: true, dtoAddressId: a.id, fromOutgAddressEdit: true, is_nl });
            }),
          )}
        </VBox>
        <div className="sub-title">{this.lbl('vehicle.transport.to')}:</div>
        <VBox center>
          {this.state.outgoingTransportToChange && (
            <ChangeLocationModal
              mediumWide={true}
              company={this.state.selectedOutgoingTransportTo}
              address={this.props.vehicle?.locationAddress}
              onClose={() => this.setState({ outgoingTransportToChange: false })}
              onConfirm={this.onSetOutgoingLocationTo}
            />
          )}
          {this.state.showOutgoingAddressEdit && (
            <ModalComponent
              onClose={() => this.setState({ showOutgoingAddressEdit: false })}
              title={this.lbl('company.property.select_country')}
            >
              <Container>
                <div className="dropdown-block">
                  <FormField>
                    <Dropdown
                      className="dropdown"
                      options={this.countryOptions}
                      value={this.state.country?.label}
                      onChange={evt => this.setState({ country: evt })}
                    />
                  </FormField>
                </div>
                <HBox center>
                  <Button
                    small
                    onClick={() => {
                      if (this.state.fromOutgAddressEdit) {
                        return this.onOutgoingAddressUpdate('from');
                      }
                      if (this.state.toOutgAddressEdit) {
                        return this.onOutgoingAddressUpdate('to');
                      }
                    }}
                  >
                    {this.lbl('confirm')}
                  </Button>
                </HBox>
              </Container>
            </ModalComponent>
          )}
          <HBox center>
            <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.setStateFn({ outgoingTransportToChange: true })}>
              {this.lbl('vehicle.location.change_transport_to')}
            </ButtonComponent>
          </HBox>
          {companyTo?.addresses?.length
            ? companyTo?.addresses.map(a =>
                this.renderAddress(a, this.state.outgoing_to_address == a.id, () => {
                  // debugger;
                  a.country?.name
                    ? this.setState({
                        selectedOutgoingTransportTo: companyTo,
                        outgoing_to_address: a.id,
                        is_nl: is_nl_to,
                        toPostcode: a?.postcode,
                      })
                    : this.setState({
                        showOutgoingAddressEdit: true,
                        dtoAddressId: a.id,
                        toOutgAddressEdit: true,
                        is_nl: is_nl_to,
                      });
                }),
              )
            : null}
        </VBox>
      </>
    );
  }

  renderIndividual() {
    const homeCompany = {
      id: '4',
      name: "In de Wal Auto's B.V.",
      addresses: IDW_ADDRESSES,
      company_from_eu: 'NL',
    };
    const companyFrom = this.state.selectedIndividualTransportFrom
      ? this.state.selectedIndividualTransportFrom
      : homeCompany;
    const companyTo = this.state.selectedIndividualTransportTo?.addresses
      ? this.state.selectedIndividualTransportTo
      : this.props.vehicle.buyingCompany;

    const is_nl = companyFrom?.company_from_eu?.toLowerCase?.() == 'nl';
    const is_nl_to = companyTo?.company_from_eu?.toLowerCase?.() == 'nl';

    return (
      <>
        <div className="sub-title">{this.lbl('vehicle.transport.from')}:</div>
        {this.state.individualTransportFromChange && (
          <ChangeLocationModal
            mediumWide={true}
            company={this.state.selectedIndividualTransportFrom}
            address={this.props.vehicle?.locationAddress}
            onClose={() => this.setState({ individualTransportFromChange: false })}
            onConfirm={this.onSetIndividualLocationFrom}
          />
        )}
        <HBox center>
          <ButtonComponent
            style={'ButtonSoftPrimary'}
            onClick={this.setStateFn({ direction: 'individual', init: true, individualTransportFromChange: true })}
          >
            {this.lbl('vehicle.location.change_transport_from')}
          </ButtonComponent>
        </HBox>
        <VBox center>
          {companyFrom.addresses.map(a =>
            this.renderAddress(a, this.state.individual_from_address == a.id, () => {
              a?.country?.name
                ? this.setState({
                    selectedIndividualTransportFrom: companyFrom,
                    individual_from_address: a.id,
                    is_nl,
                    fromPostcode: a?.postcode,
                  })
                : this.setState({
                    showIndividualAddressEdit: true,
                    dtoAddressId: a.id,
                    fromIndividualAddressEdit: true,
                    is_nl,
                  });
            }),
          )}
        </VBox>
        <div className="sub-title">{this.lbl('vehicle.transport.to')}:</div>
        <VBox center>
          {this.state.individualTransportToChange && (
            <ChangeLocationModal
              mediumWide={true}
              company={this.state.selectedIndividualTransportTo}
              address={this.props.vehicle?.locationAddress}
              onClose={() => this.setState({ individualTransportToChange: false })}
              onConfirm={this.onSetIndividualLocationTo}
            />
          )}
          {this.state.showIndividualAddressEdit && (
            <ModalComponent
              onClose={() => this.setState({ showIndividualAddressEdit: false })}
              title={this.lbl('company.property.select_country')}
            >
              <Container>
                <div className="dropdown-block">
                  <FormField>
                    <Dropdown
                      className="dropdown"
                      options={this.countryOptions}
                      value={this.state.country?.label}
                      onChange={evt => this.setState({ country: evt })}
                    />
                  </FormField>
                </div>
                <HBox center>
                  <Button
                    small
                    onClick={() => {
                      if (this.state.fromIndividualAddressEdit) {
                        return this.onIndividualAddressUpdate('from');
                      }
                      if (this.state.toIndividualAddressEdit) {
                        return this.onIndividualAddressUpdate('to');
                      }
                    }}
                  >
                    {this.lbl('confirm')}
                  </Button>
                </HBox>
              </Container>
            </ModalComponent>
          )}
          <HBox center>
            <ButtonComponent style={'ButtonSoftPrimary'} onClick={this.setStateFn({ individualTransportToChange: true })}>
              {this.lbl('vehicle.location.change_transport_to')}
            </ButtonComponent>
          </HBox>
          {companyTo?.addresses?.length
            ? companyTo?.addresses.map(a =>
                this.renderAddress(a, this.state.individual_to_address == a.id, () => {
                  // debugger;
                  a.country?.name
                    ? this.setState({
                        selectedIndividualTransportTo: companyTo,
                        individual_to_address: a.id,
                        is_nl: is_nl_to,
                        toPostcode: a?.postcode,
                      })
                    : this.setState({
                        showIndividualAddressEdit: true,
                        dtoAddressId: a.id,
                        toIndividualAddressEdit: true,
                        is_nl: is_nl_to,
                        toPostcode: a?.postcode,
                      });
                }),
              )
            : null}
        </VBox>
      </>
    );
  }

  renderTakeoutModal() {
    return (
      <ModalComponent onClose={this.reset.bind(this)} title="Klaarzetten">
        <Container>
          <VBox className={styles.containerButtonModal}>
            {['front', 'back', 'done', '0'].map(n => (
              <Button className={styles.buttonModal} onClick={() => this.props.takeout(n, this.reset.bind(this))} key={n}>
                {this.lbl(`vehicle.property.task_move_car_for_takeout.${n}`)}
              </Button>
            ))}
          </VBox>
        </Container>
      </ModalComponent>
    );
  }
}

VehicleTransportCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([
      `${REQUEST_VEHICLE_PROPERTIES}-${ownProps.vehicle?.id}`,
      REQUEST_VEHICLE_PROPERTY_UPDATE,
      `${REQUEST_COMPANY}-${getPropByName(ownProps.vehicle, 'creditor_company')}`,
    ]),
    creditorCompany: selectCompany(getPropByName(ownProps.vehicle, 'creditor_company')),
    countries: selectCountries(),
    locale: makeSelectLocale(),
    permissions: selectPermissions(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    takeout(id, callback) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'task_move_car_for_takeout', id, callback));
    },
    deplate(callback) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'task_remove_plates', '1', callback));
    },
    overrule_outgoing_transport(callback) {
      dispatch(setVehicleProperty(ownProps.vehicle.id, 'overrule_outgoing_transport', callback));
    },
    start(
      direction,
      from_address_id,
      to_address_id,
      from_company_id,
      from_company_name,
      to_company_id,
      to_company_name,
      transport_from_address_postcode,
      transport_to_address_postcode,

      is_nl,
      callback,
    ) {
      const addressesFromProp =
        direction == 'incoming'
          ? 'transport_from_address_id'
          : direction == 'individual'
          ? 'transport_individual_from_address_id'
          : 'transport_outgoing_from_address_id';
      const addressesToProp =
        direction == 'incoming'
          ? 'transport_to_address_id'
          : direction == 'individual'
          ? 'transport_individual_to_address_id'
          : 'transport_outgoing_to_address_id';
      const companyIdFrom =
        direction == 'incoming'
          ? 'transport_incoming_from_company_id'
          : direction == 'individual'
          ? 'transport_individual_from_company_id'
          : 'transport_outgoing_from_company_id';
      const companyIdTo =
        direction == 'incoming'
          ? 'transport_incoming_to_company_id'
          : direction == 'individual'
          ? 'transport_individual_to_company_id'
          : 'transport_outgoing_to_company_id';
      const companyNameFrom =
        direction == 'incoming'
          ? 'transport_incoming_from_company_name'
          : direction == 'individual'
          ? 'transport_individual_from_company_name'
          : 'transport_outgoing_from_company_name';
      const companyNameTo =
        direction == 'incoming'
          ? 'transport_incoming_to_company_name'
          : direction == 'individual'
          ? 'transport_individual_to_company_name'
          : 'transport_outgoing_to_company_name';
      const transportRequested =
        direction == 'incoming'
          ? 'transport_requested'
          : direction == 'individual'
          ? 'transport_individual_requested'
          : 'transport_outgoing_requested';
      const transportIsNl =
        direction == 'incoming'
          ? 'transport_is_nl'
          : direction == 'individual'
          ? 'transport_individual_is_nl'
          : 'transport_outgoing_is_nl';
      const directionProp = direction == 'incoming' ? 'transport_direction' : 'direction';
      const transport_incoming_date =
        direction == 'incoming'
          ? 'transport_incoming_to_be_planned_date'
          : direction == 'individual'
          ? 'transport_individual_filled_date'
          : 'transport_outgoing_filled_date';

      const postcodeFrom = 'transport_from_address_postcode';
      const postcodeTo = 'transport_to_address_postcode';
      let propsArray = [
        // 'transport_initiated',
        // null,
        transportRequested,
        '1',
        directionProp,
        direction,
        addressesFromProp,
        from_address_id,
        addressesToProp,
        to_address_id,
        companyIdFrom,
        from_company_id,
        companyNameFrom,
        from_company_name,
        companyIdTo,
        to_company_id,
        companyNameTo,
        to_company_name,
        transport_incoming_date,
        date_done,

        transportIsNl,
        is_nl ? '1' : '0',
      ];
      if (transport_from_address_postcode) {
        propsArray?.push(postcodeFrom);
        propsArray?.push(transport_from_address_postcode);
      }

      if (transport_to_address_postcode) {
        propsArray?.push(postcodeTo);
        propsArray?.push(transport_to_address_postcode);
      }

      dispatch(
        setVehicleProperties(
          ownProps.vehicle.id,
          _.chunk(propsArray, 2).map(pair => ({
            propertyName: pair[0],
            propertyValue: pair[1],
          })),
          callback,
        ),
      );
    },
    deleteProperty(vehicleId, types, callback) {
      types.map(type => dispatch(deleteVehicleProperty(vehicleId, type, callback)));
    },
    fetchVehicle() {
      dispatch(fetchVehicle(ownProps.vehicle?.id));
    },
    fetch(addressId, callback) {
      dispatch(fetchAddress(addressId, callback));
    },
    fetchCompany(companyId, callback) {
      dispatch(fetchCompany(companyId, callback));
    },
    updateAddress(companyId, addressId, addressDto, callback) {
      dispatch(updateAddress(companyId, addressId, addressDto, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleTransportCard = compose(withConnect, withRouter)(VehicleTransportCardComp);
